'use client'
import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {Box, Flex} from '@chakra-ui/layout';
import {FormControl, FormErrorMessage, Input} from '@chakra-ui/react';
import {IconButton} from '@chakra-ui/button';
import {MdCheck} from 'react-icons/md';
import {forwardRef} from '@chakra-ui/system';
import useProfileApi from '../lib/useProfileApi';
const ProfilePseudoForm = forwardRef((props, ref) => {
  const {
    profileId,
    profilePseudo,
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    formState: { isSubmitting, isValid }
  } = useForm();
  const profileApi = useProfileApi();
  const onSubmit = async (data) => {
    try {
      if(onSubmitting) {
        onSubmitting();
      }
      const pseudo = data.pseudo;
      if(pseudo && profileId) {
        await profileApi.updatePseudo(pseudo, profileId);
      }
      if(onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if(profilePseudo) {
      setValue('pseudo', profilePseudo);
    }
  }, [profilePseudo]);
  useEffect(() => {
    if(onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          <Flex
            alignItems={'center'}
          >
            <FormControl isInvalid={errors && errors.pseudo}>
              <Input
                placeholder='Full Name'
                {...register('pseudo', {
                  required: true,
                  minLength: 3
                })}
              />
              <FormErrorMessage>{errors && errors.pseudo}</FormErrorMessage>
            </FormControl>
            <IconButton
              style={{
                display: hideSave ? 'none' : 'inherit',
              }}
              ref={ref}
              icon={<MdCheck />}
              ml={2}
              type={'submit'}
              aria-label='check'
              variant='greyFill'
              isLoading={isSubmitting}
              isDisabled={!isValid}
            />
          </Flex>
        </form>
      </Box>
    </>
  );
});
export default ProfilePseudoForm;
